// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_jx-0";